import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import LeftContent from './leftContent';
import RightContent from './rightContent';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const { leftContentData, rightContentData } = content;

        return (
            <div className={styles.content}>
                <LeftContent content={leftContentData} />
                <RightContent content={rightContentData} />
                <div className="clear" />
            </div>
        );
    }
}

export default Content;
